var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2.5V4.21667C14.075 4.93333 15.8333 7.16667 15.8333 9.80833C15.8333 12.45 14.075 14.675 11.6667 15.3917V17.1167C15 16.3583 17.5 13.375 17.5 9.80833C17.5 6.24167 15 3.25833 11.6667 2.5ZM13.75 9.80833C13.75 8.33333 12.9167 7.06667 11.6667 6.45V13.1417C12.9167 12.55 13.75 11.275 13.75 9.80833ZM2.5 7.30833V12.3083H5.83333L10 16.475V3.14167L5.83333 7.30833H2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.7050d70928a179ba9f089d75bb03b483.svg";
export { ForwardRef as ReactComponent };